<template>
  <div class="human-filters-overlay column items-start justify-start">
    <div class="row items-center justify-between full-width q-mb-lg">
      <div class="score-label">Human Factor Score:</div>

      <DHumanFiltersChip :score="human_filters.score" :white_bg="true" />
    </div>

    <div class="head full-width column items-start justify-start">
      <div class="caption" v-if="human_filters.caption">
        {{ human_filters.caption }}
      </div>

      <div class="title" v-if="human_filters.title">
        {{ human_filters.title }}
      </div>
    </div>

    <div class="description full-width" v-if="human_filters.description">
      {{ human_filters.description }}
    </div>
  </div>
</template>

<script>
import DHumanFiltersChip from "./DHumanFiltersChip";

export default {
  name: "DHumanFiltersOverlay",
  components: {
    DHumanFiltersChip,
  },
  props: {
    human_filters: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="scss" scoped>
.human-filters-overlay {
  position: absolute;
  top: 12px;
  left: 16px;
  width: calc(100% - 32px);
  z-index: 15;
  color: white;
  letter-spacing: 0.2px;
  cursor: zoom-in;

  .head {
    margin-bottom: 12px;
  }

  .score-title {
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
  }

  .caption {
    font-size: 9px;
    font-weight: 800;
    line-height: 16px;
    margin-bottom: 2px;
  }

  .title {
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
  }

  .dsecription {
    font-size: 12px;
    font-weight: 400;
    line-height: 16.8px;
  }
}
</style>
